Expander = {
    init: function (collection) {
        this.el = collection.find('[expander]');
        if(!this.el.length) return;

        this.el.each(function () {
            Expander.bind($(this));
        })
    },

    bind: function (header) {

        var contents = header.next();
        contents.css({'display':'none'});
        contents.find('ul').css({'margin': '0px', 'padding-top': '15px', 'padding-bottom': '15px'});

        header.click(function () {

            var content = header.next();

            if($(this).is('.expanded')){
                $(this).removeClass('expanded');
                content.slideUp(300);
            } else {
                $(this).addClass('expanded');
                content.slideDown(300);
            }


        })

    },

};